"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactflow_1 = require("reactflow");
var node_1 = __importDefault(require("../../node"));
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var workflow_1 = require("../../../../../../../../reducers/slices/workflow/workflow");
var react_redux_1 = require("react-redux");
var data_map_modal_1 = __importDefault(require("../../data_map/data_map_modal"));
var doshx_controls_web_1 = require("doshx_controls_web");
var main_1 = require("../../../../../../../../reducers/slices/main");
var fields_from_schema_1 = require("../../../helpers/fields_from_schema");
var MapDataNode = function (props) {
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setNodeData = function (data) {
        dispatch((0, workflow_1.setNode)(__assign(__assign({}, props), { data: data })));
    };
    var flow = null;
    try {
        flow = (0, reactflow_1.useReactFlow)();
    }
    catch (error) {
        if (props.id) {
            console.error(error);
        }
    }
    var getSchema = function () {
        if (flow) {
            var nodes = flow.getNodes();
            var edges = flow.getEdges();
            return (0, fields_from_schema_1.combineSchemas)(props, nodes, edges);
        }
        return null;
    };
    var configurationComponent = function () { return ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Fields", size: "small", onClick: function () {
            var _a;
            var schema = getSchema();
            dispatch((0, main_1.setContentModal)({
                title: "Map your fields",
                content: ((0, jsx_runtime_1.jsx)(data_map_modal_1.default, { schema: schema, value: (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.mapping, onSave: function (mapping) { return setNodeData(__assign(__assign({}, data), { config: __assign(__assign({}, data === null || data === void 0 ? void 0 : data.config), { mapping: mapping }) })); } })),
            }));
        } })); };
    return ((0, jsx_runtime_1.jsxs)(node_1.default, __assign({ category: "action", icon: pro_light_svg_icons_1.faExchange, configurationComponent: configurationComponent, data: data }, props, { children: [(0, jsx_runtime_1.jsx)(reactflow_1.Handle, { type: "target", position: reactflow_1.Position.Left, className: "rounded w-2 h-5 !bg-blue-300" }), (0, jsx_runtime_1.jsx)(reactflow_1.Handle, { type: "source", position: reactflow_1.Position.Right, className: "rounded w-2 h-5 !bg-secondary" })] })));
};
exports.default = (0, react_1.memo)(MapDataNode);
